// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import Counting from './Counting';
import Hero from './Horo';
import Partner from './Partner';
import PrizePool from './PrizePool';

function Home() {
  return (
    <>
      <Hero />
      <PrizePool />
      <Counting />
      <Partner />
    </>
  );
}

export default Home;
